<template>
  <div>
    <AllResults :selectedStatuses="statuses"></AllResults>
  </div>
</template>

<script>
import { defineAsyncComponent } from "vue";
const AllResults = defineAsyncComponent(() =>
  import("@/components/results/AllResults")
);
export default {
  components: {
    AllResults,
  },
  data() {
    return {
      statuses: "ARCHIVED",
    };
  },
};
</script>
